package com.appcreator.blueprint.firebase.auth

import com.appcreator.blueprint.core.Action
import com.appcreator.blueprint.core.ActionClass
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("FirebaseAuthLogout")
@ActionClass(
    group = FirebaseAuthConsts.group,
    title = "Logout",
    isExtraPlugin = true,
    availableFrom = "0.0.1"
)
class FirebaseAuthLogoutAction: Action
